module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "width": "560px",
      "modal-append-to-body": false,
      "close-on-click-modal": false,
      "custom-class": "link-crowd-dialog"
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [(!_vm.isEdit) ? _c('div', {
    staticClass: "link-crowd-body link-crowd-body--view"
  }, [_c('div', {
    staticClass: "link-crowd-tags"
  }, [_vm._l((_vm.viewTagList), function(t, i) {
    return _c('el-tag', {
      key: i,
      staticClass: "link-crowd-view-tag",
      attrs: {
        "type": "info"
      }
    }, [_vm._v("\n            " + _vm._s(t) + "\n         ")])
  }), _vm._v(" "), (_vm.viewTagList.length === 0) ? _c('span', {
    staticClass: "link-crowd-empty"
  }, [_vm._v("暂无关联人群")]) : _vm._e()], 2)]) : _c('div', {
    staticClass: "link-crowd-body link-crowd-body--edit"
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 适用人群\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "link-crowd-edit-inner"
  }, [_c('div', {
    staticClass: "crowd-options"
  }, _vm._l((_vm.crowdOptions), function(opt) {
    return _c('div', {
      key: opt.id,
      staticClass: "crowd-option",
      class: {
        'is-selected': _vm.isCrowdSelected(opt.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggleCrowd(opt.id)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(opt.name) + "\n                  ")])
  }), 0)])], 2)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer link-crowd-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isEdit) ? [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.enterEdit
    }
  }, [_vm._v("编辑")])] : [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83238fa4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/LinkCrowdDialog.vue
// module id = 1095
// module chunks = 0